import styled from "styled-components";
import { Input } from "reactstrap";

export const Container = styled.div`
  margin: auto;
  display: block;
  text-align: center;
`;

export const BootstrapInput = styled(Input)`
  max-width: 100px;
  margin: auto;
`;

export const Strong = styled.strong``;
